import _defineProperty from "@babel/runtime/helpers/defineProperty";
export class PriceModel {
  constructor(priceModel) {
    _defineProperty(this, "amount", void 0);
    this.amount = priceModel.amount;
  }
  static fromV1(multiCurrencyPrice, _ref) {
    let {
      useConvertedPrices
    } = _ref;
    return new PriceModel({
      amount: useConvertedPrices ? multiCurrencyPrice == null ? void 0 : multiCurrencyPrice.convertedAmount : multiCurrencyPrice == null ? void 0 : multiCurrencyPrice.amount
    });
  }
}
//# sourceMappingURL=Price.model.js.map